import React, { useState } from "react"
import styled from '@emotion/styled';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from 'swiper/react';
import { useStaticQuery, graphql } from "gatsby"
import SwiperCore, { Autoplay, Lazy } from 'swiper';
import 'swiper/swiper.scss'
import * as breakpoint from '../../../styles/breakpoints.module.scss';

SwiperCore.use([Autoplay,Lazy]);

const GoodsList = ({ list }) => {

  const [swiper, setSwiper] = useState(null);
  
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const data = useStaticQuery(graphql`
    query Slider {
      btnArrow : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/btn_arrow.png"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      
    }
  `);
  

  const params = {
    allowTouchMove:true,
    lazyload : {
      loadPrevNext:true
    },
    spaceBetween: 0,
    slidesPerView: 'auto',
    onSwiper: setSwiper,
    onSlideChange: (e) =>{
      if(e.isBeginning)
        setIsBeginning(true);
      else
        setIsBeginning(false);

      if(e.isEnd)
        setIsEnd(true);
      else
        setIsEnd(false);
    }
    
  }

  return (
    <GoodsListWrapper>
      <Swiper {...params}>
        {list.map((item,index) => 
        <SwiperSlide key={`list_${index}`}>
          <GoodsItem>
            <GatsbyImage image={item.image} alt={item.alt} />
          </GoodsItem>
        </SwiperSlide>)}
      </Swiper>
      <NavButton href="#" direction={'left'} className={'button-prev'+(isBeginning ? ' hided' : '')} onClick={(e) => {
          e.preventDefault();
          swiper.slidePrev();
        }}>
          <GatsbyImage image={getImage(data.btnArrow)} alt={'Prev'} />
      </NavButton>
      <NavButton href="#" direction={'right'} className={'button-next'+(isEnd ? ' hided' : '')} onClick={(e) => {
          e.preventDefault();
          swiper.slideNext();
        }}>
        <GatsbyImage image={getImage(data.btnArrow)} alt={'Next'} />
      </NavButton>
    </GoodsListWrapper>
  );
};


export default GoodsList;

const NavButton = styled.a`
  display:block;
  width:48px;
  height:48px;
  background: #FFFFFF;
  /* Shadow / 1dp */

  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 24px;

  

  position:absolute;
  top:50%;
  margin-top:-24px;

  ${props => props.direction === "left" ? `
  left:0;
  transform:rotate(180deg);margin-left:-64px;`: `right:0;margin-right:-64px;`}

  &.hided{
    opacity:.5;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    display:none;
  }

`

const GoodsListWrapper = styled.div`
  position:relative;
  z-index:2;
  display:flex;
  width:calc(100% - 160px);
  max-width:1440px;
  margin:48px auto;
  .swiper-container{
    width:100%;
  }
  .swiper-wrapper, .swiper-container{
    overflow:visible;
  }

  @media only screen and (min-width: ${breakpoint.mdMin}){
    .swiper-container{
      overflow:hidden;
    }
    .swiper-wrapper{
      .swiper-slide{width:20%;}
    }
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin:28px auto 32px;
    width:100%;
    .swiper-container{
      width:calc(100% + 24px);
      margin:0 -12px;
    }
    
    .swiper-wrapper{
      width:192px;
    }
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:16px auto 16px;
    .swiper-container{
      width:calc(100% + 16px);
      margin:0 -8px;
    }
    .swiper-wrapper{
      width:160px;
    }
  }
`;

const GoodsItem = styled.div`
  width:calc(100% - 32px);
  position:relative;
  > *{
    box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
    border-radius: 6px;
    z-index:1;
    overflow:hidden;
  }

  @media only screen and (min-width: ${breakpoint.mdMin}){
    padding:0 16px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:calc(100% - 24px);
    padding:0 12px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:calc(100% - 16px);
    padding:0 8px;
  }
`
